/*
 * VatomInc. Copyright (c) 2022, all rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in the root directory of this source tree.
 */

import { BVatomSnapshot, BVatomTokenType, VatomApiType } from '@vatom/BVatom/plugin'
import { ProfileSnapshot, VatomInc } from '@vatom/sdk/core'
import _ from 'lodash'
import { getSnapshot } from 'mobx-state-tree'

export type VatomInfo = {
  id: string
  properties: any
  resources: { [name: string]: string }
  faceProperties?: any
}

export default class BridgeV1 {
  vatomIncApi: VatomInc.VatomIncApi
  api: VatomApiType
  vatom: BVatomTokenType
  // face: FaceStoreType
  version: number

  constructor(
    api: VatomApiType,
    vatomIncApi: VatomInc.VatomIncApi,
    vatom: BVatomTokenType
    // face: FaceStoreType
  ) {
    this.api = api
    this.vatom = vatom
    this.vatomIncApi = vatomIncApi
    // this.face = face
    this.version = 1
  }

  init() {
    const data = this.encodeVatom(getSnapshot(this.vatom))
    // data.vatomInfo.faceProperties = this.face.properties || {}

    // TODO
    // if (this.vatomNet.store.userID != null) {
    // 	this.vatomNet.UserManager.getCurrentUser().then((uv) => {
    // 		data["user"] = this.encodeUser(uv);
    // 	});
    // }
    // This response has a special message name
    data._responseName = 'vatom.init-complete'

    // Done, return payload
    return data
  }

  getChildren() {
    const children = this.vatom.getChildren()
    const vatomInfos = []
    for (const token of children) {
      const vatom = token as unknown as BVatomSnapshot
      vatomInfos.push(this.encodeVatom(vatom))
    }
    return {
      items: vatomInfos,
      _responseName: 'vatom.children.get-response'
    }
  }

  // rpc (payload) {
  //   // sends on payload to all faces
  //   Events.callEvent('websocket.rpc', payload)
  //   return {}
  // }

  performAction(payload: { actionName: string; actionData: any }) {
    // Perform Vatom action
    return this.vatom.performAction(payload.actionName, payload.actionData)
  }

  // TODO
  // getProfile(payload) {
  // 	// Get user details
  // 	return this.vatomNet.UserManager.getCurrentUser().then((user) => {
  // 		// Got it, send response
  // 		return {
  // 			firstName: user.firstName,
  // 			lastName: user.lastName,
  // 			avatarURL: this.vatomNet.UserManager.encodeAssetProvider(
  // 				user.avatarURL
  // 			),
  // 		};
  // 	});
  // }

  patchVatom(payload: any) {
    // Perform patch operation
    return this.api.client.request('PATCH', '/vatoms', payload, true)
  }

  // TODO
  // getVatom(payload) {
  // 	// Get details from a vatom ID
  // 	return this.vatomNet.Vatoms.getUserVatoms([payload.id]).then((vatom) =>
  // 		this.encodeVatom(vatom[0])
  // 	);
  // }

  getUser() {
    const us = this.vatom.properties.owner

    return this.vatomIncApi.getPublicProfile(us).then(pu => {
      return this.encodeUser(pu)
    })
  }

  encodeVatom(vatom: BVatomSnapshot): { vatomInfo: VatomInfo; _responseName?: string } {
    // Create resource list
    const resources: { [name: string]: string } = {}
    for (let i = 0; i < vatom.properties.resources.length; i++) {
      resources[vatom.properties.resources[i].name] = this.api.vatomApi.encodeAssetProvider(
        vatom.properties.resources[i].value.value
      )
    }
    if (vatom.private && vatom.private.resources) {
      for (let p = 0; p < vatom.private.resources.length; p++) {
        resources[vatom.private.resources[p].name] = this.api.vatomApi.encodeAssetProvider(
          vatom.private.resources[p].value
        )
      }
    }

    const vatomInfo: VatomInfo = {
      id: vatom.id,
      properties: _.merge({}, vatom.properties, vatom.private),
      resources: resources
    }
    // Create payload
    return {
      vatomInfo
    }
  }

  encodeUser(user: ProfileSnapshot | undefined) {
    if (!user) return

    return {
      id: user.sub,
      first_name: user.name.split(' ')[0],
      last_name: user.name.split(' ')[1],
      avatarURL: this.api.vatomApi.encodeAssetProvider(user.picture)
    }
  }
}
